import { render, staticRenderFns } from "./ButtonsTopbar.vue?vue&type=template&id=9d3f3c54&"
import script from "./ButtonsTopbar.vue?vue&type=script&lang=js&"
export * from "./ButtonsTopbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports